import Vue from 'vue';
export default {
    data () {
        return {
            __resize: null
        };
    },
    mounted () {
        this.__resize =  _.throttle(() => {
          this.chart && this.chart.resize && this.chart.resize();
        }, 300);

        Vue.$EventBus.$on('resize', this.__resize);
        window.addEventListener('resize', this.__resize, false);
    },
    destroyed () {
        Vue.$EventBus.$off('resize', this.__resize);
        window.removeEventListener('resize', this.__resize);
        this.chart && this.chart.dispose && this.chart.dispose();
    }
};



// WEBPACK FOOTER //
// ./src/component/charts/resize.mixin.js